module.exports = __webpack_public_path__ + "img/snow.b3d1d439.png";